import React from "react";

const unassigned = ({ color }) => {
  return (
    <div>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_18604_88514)">
          <path
            d="M10 1.66797C14.6031 1.66797 18.3333 5.39945 18.3333 10.0013C18.3333 14.6031 14.6031 18.3346 10 18.3346"
            stroke={color}
            stroke-width="1.67"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M7.50521 17.9183C6.5149 17.581 5.58464 17.0939 4.77439 16.4568M4.77439 3.5465C5.58464 2.91879 6.5149 2.42224 7.50521 2.08496M1.67188 8.54005C1.85193 7.57507 2.22203 6.63818 2.75219 5.78561M1.67188 11.4632C1.85193 12.4282 2.22203 13.365 2.75219 14.2176"
            stroke={color}
            stroke-width="1.67"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M6.67188 13.75C8.39904 11.9183 11.5928 11.8322 13.3385 13.75M11.8535 8.125C11.8535 9.1605 11.0231 10 9.99896 10C8.97471 10 8.14444 9.1605 8.14444 8.125C8.14444 7.08947 8.97471 6.25 9.99896 6.25C11.0231 6.25 11.8535 7.08947 11.8535 8.125Z"
            stroke={color}
            stroke-width="1.67"
            stroke-linecap="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_18604_88514">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};

export default unassigned;
